export default __webpack_public_path__ + "static/media/amex.b6b3f51d.svg";